import { Controller } from "@hotwired/stimulus"
import { renderDonutChart, renderBracketChart, updateDonutChart } from "../modules/salary_lab/chart_renderer"

/**
 * Stimulus controller for SalaryLab Chart.js charts.
 * Listens for salary-lab-calculator:calculated events to update charts.
 */
export default class extends Controller {
  static targets = ["donutCanvas", "bracketCanvas"]

  connect() {
    this._donutChart = null
    this._bracketChart = null
  }

  disconnect() {
    if (this._donutChart) this._donutChart.destroy()
    if (this._bracketChart) this._bracketChart.destroy()
  }

  /**
   * Called when the calculator dispatches a 'calculated' event.
   * Renders or updates both charts with the new data.
   */
  update({ detail }) {
    if (!detail) return

    if (this.hasDonutCanvasTarget) {
      if (this._donutChart) {
        updateDonutChart(this._donutChart, detail)
      } else {
        this._donutChart = renderDonutChart(this.donutCanvasTarget, detail)
      }
    }

    if (this.hasBracketCanvasTarget && detail.tax_breakdown) {
      this._bracketChart = renderBracketChart(this.bracketCanvasTarget, detail.tax_breakdown)
    }
  }
}
